.active {
  background-color: var(--bc-color-primary);
  color: var(--bc-color-text-light-solid);
  border-color: var(--bc-color-primary);

  svg {
    fill: var(--bc-color-text-light-solid);
  }
}

.emoji {
  margin-right: 4px;
}
